import { getSize } from './iterable/getSize';

function totalProfiles({ shopId, type }) {
  return function select(state) {
    return getSize(state.getIn(['data', 'shopsData', shopId, 'profiles', type, 'byId']));
  };
}

export const profiles = {
  total: totalProfiles,
};

function currentShop(state) {
  return userShops(state).getIn(['byId', currentShopId(state)]);
}

function currentShopId(state) {
  return userShops(state).get('current');
}

function shopsAreLoaded(state) {
  return userShops(state).has('byId');
}

function shopsById(state) {
  return userShops(state).get('byId');
}

function userHasMultipleShops(state) {
  return getSize(userShops(state).get('byId')) > 1;
}

function userHasShops(state) {
  return getSize(userShops(state).get('byId')) > 0;
}

function userShops(state) {
  return state.get('shops');
}

export const shops = {
  currentShop,
  currentShopId,
  shopsAreLoaded,
  shopsById,
  userHasMultipleShops,
  userHasShops,
  userShops,
};
